export const images = {
  hero: {
    home: "/images/hero-home.webp",
    serviceLocation: "/images/service-location-hero.webp",
    hub: "/images/hub-hero.webp",
  },
  services: {
    rohrreinigung: "/images/rohrreinigung.webp",
    'klempner-notdienst': "/images/klempner-notdienst.webp",
    sanitaer: "/images/sanitaer.webp",
  },
  content: {
    serviceTech1: "/images/tech-1.webp",
    serviceTech2: "/images/tech-2.webp",
    customerSatisfaction: "/images/contact-hero.webp"
  },
  locations: [
    "/images/service-location-hero.webp",
    "/images/sanitaer-dienst.webp"
  ]
};
